/**
 * AB Announcement Bar Component
 */

class ABAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.swiper');
    if (!this.container) return;

    this.init();
  }

  init() {
    const options = {
      loop: true,
      autoplay: {
        delay: parseInt(this.dataset.autoplaySpeed) || 3000,
        disableOnInteraction: false,
      },
      effect: this.dataset.animationType || 'slide',
      speed: 800,
      slidesPerView: 1,
      centeredSlides: true,
    };

    // Initialize Swiper
    if (typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(this.container, options);
    } else {
      // Fallback if Swiper is not loaded
      console.warn('Swiper.js not found for AB Announcement Bar');
    }
  }
}

customElements.define('ab-announcement-bar', ABAnnouncementBar);
